import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Rodal from 'rodal';
import $ from 'jquery';
import OpenSeadragon from 'openseadragon';
import {
  Tooltip,
  withTooltip,
} from 'react-tippy';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { panzoom } from 'jquery.panzoom';
import { Loader } from './index';
import { data } from '../utils/config';
import { pad } from '../utils/_helpers';

const keysSubDetail = data.keysSubDetail;
const keysData = data.keysData;

class Button extends Component {
  render() {
    const aStyle = {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      float: 'left',
      width: '100%',
    };
    const { number, id, activeNumber, onPressNumber, loading, data = {}, open, message, error,
    filterDetails, loadedSale } = this.props;

    if (open && this._tooltip) {
      this._tooltip.showTooltip();
    }

    let sale = '';
    let isSale = '';
    if (loadedSale && filterDetails) {
      const padNumber = `N${pad(number)}`;
      const onSale = filterDetails.find(detail => detail.number === padNumber);
      isSale = onSale ? 'sale' : 'nosale';
    }

    sale = Boolean(data.sale) ? 'sale' : 'nosale';
    if (activeNumber === number) {
      isSale = sale;
    }

    return (
      <Tooltip
        ref={el => this._tooltip = el }
        trigger='click'
        interactive
        useContext
        className={`${error ? 'error' : ''}`}
        distance={10}
        onRequestClose={() => {
          
        }}
        animateFill={false}
        html={(
          <div>
            {
              loading ?
              <Loader /> : 
              error ? 
              <div className={`row mapdetail_row splitted error`}>
                <p>{message}</p>
              </div> :
              Object.keys(data).map((item, i) => {
                const title = keysSubDetail[item] ? keysSubDetail[item] : item;
                let desc = '';

                switch (item) {
                  case 's_url': {
                    desc = <a href={`${data[item]}`} title={`${data[item]}`} target="_blank" style={aStyle}>{data[item]}</a>;
                    break;
                  }
                  case 'p_contact': {
                    desc = <a href={`mailto:${data[item]}`} title={`${data[item]}`} target="_blank">{data[item]}</a>;
                    break;
                  }
                  case 'sale': {
                    desc = <span>{data[item] ? 'Yes' : 'No'}</span>
                    break;
                  }
                  case 's_price': {
                    desc = `${data.s_cur || ''} ${data[item]}`;
                    break;
                  }
                  default: {
                    desc = data[item] || '';
                    break
                  }
                }


                const isCur = item === 's_cur' || false;
                const isSale = (item === 'sale') ? sale : '';
                if (isCur) return null;
                return (
                  <div key={i} className={`row mapdetail_row splitted ${isSale}`}>
                    <div className="col-lg-3 col-md-3 mapdetail_title small">{title.toUpperCase()}</div>
                    <div className="col-lg-9 col-md-9 mapdetail_desc small">{desc}</div>
                  </div>
                )
              })
            }
          </div>
        )}
      >
        <button className={`mapdetail_numbers ${isSale}`} onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if ( Number(activeNumber) !== Number(number)) {
            onPressNumber(id, number);
          } 
        }}>{number}</button>
      </Tooltip>
    )
  }
}

export default class MapDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      details: {},
      loading: true,
      response: {},
      visiblePrint: null,
      activeNumber: null,
      message: '',
      error: false,
      loadSale: false,
      errorSale: '',
      saleDetails: [],
      loadedSale: false,
    };

    this.keys = keysData;

    this.toggle = this.toggle.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.putData = this.putData.bind(this);
  }

  toggle() {
    this.setState({
      visible: !this.state.visible
    });
  }

  putData(response, number) {
    let message = '';
    let error = false;
    if (response && !response.status && response.message) {
      message = response.message;
      error = true;
    }
    this.setState({
      response: response,
      loading: false,
      activeNumber: number,
      message,
      error,
    })
  }

  show(data, visiblePrint) {
    // interact DOM via jquery
    $('body').addClass('scroll-off');
    let state = {
      visible: true,
    };
    if (data) {
      state.details = data;
      // this.setState({ ...state }, () => {});
    }
    this.setState({...this.state, ...state}, () => {
      if (this.state.details && this.state.details.tiles) {
        const options = this.state.details.tiles;
        $('#container').show();
        this.opensDragon = OpenSeadragon({
          id: "container",
          prefixUrl: `${process.env.PUBLIC_URL}${options.prefixUrl}`,
          tileSources: [{
            type: "zoomifytileservice",
            width: options.width,
            height: options.height,
            tilesUrl: `${process.env.PUBLIC_URL}${options.url}`,
          }]
        });
      } else if (this.opensDragon) {
        $('#container').hide();
        this.opensDragon.destroy();
      }
    });

    if (visiblePrint >= 0) {
      setTimeout(() => {
        this.setState({ ...this.state, visiblePrint });
      }, 500);
    }

    // load sale info
    this.setState({
      loadSale: true,
      errorSale: '',
    }, () => {
      const errorMessage = 'error loading sale details';
      this.props.onGetSaleDetails()
        .then((response) => {
          if (response.data && response.data.status) {
            const saleDetails = response.data.data || [];
            this.setState({
              loadSale: false,
              saleDetails,
              loadedSale: true,
            });
          } else {
            this.setState({
              loadSale: false,
              errorSale: response.data.message || errorMessage,
              loadedSale: false,
            });
          }
        })
        .catch((err = {}) => {
          const message = err.message || errorMessage; 
          this.setState({
            loadSale: false,
            errorSale: message,
          });
        });
    }); 
  }

  hide() {
    // interact DOM via jquery
    $('body').removeClass('scroll-off');
    this.setState({
      visible: false,
      response: {},
      visiblePrint: null,
      loading: true,
      activeNumber: '',
      message: '',
      error: false,
      loadSale: false,
      loadedSale: false,
      errorSale: '',
    }, () => {
      this.props.closeDetails();
    });
  }

  render() {
    const that = this;
    const url = (this.state.details && this.state.details.url) ? this.state.details.url : '';
    const details = this.state.details;
    const title = details.title || '';
    const toArray = Object.keys(details).map(key => {
      return {
        key: key,
        value:details[key]
      }
    });

    const sortItemsArray = toArray.sort((a,b) => {
      if (this.keys[a.key] && this.keys[b.key]) {
        if ( this.keys[a.key].order < this.keys[b.key].order ) return -1;
        if ( this.keys[a.key].order > this.keys[b.key].order ) return 1;
      }
      return 0;
    });

    const filterDetails = (this.state.saleDetails || []).filter(detail => {
      const piece = 'HD_'+detail.piece;
      return details.id === piece;
    });

    return (
      <Rodal 
        visible={this.state.visible} 
        onClose={this.hide}
        showCloseButton={false}
        className='popup-data'
        closeMaskOnClick={false}
        customStyles={{
          width: '90%',
          minHeight: '400px',
        }}
      >
        <button className="popup-data_close" onClick={this.hide}><i className="fas fa-times"></i></button>
        <div className="row popup-data_row">
          <div className="col-lg-5 col-md-6 col-sm-12 popup-data_col">
            <div id="container" className="container-images focal" />
          </div>
          <div className="col-lg-7 col-md-6 col-sm-12 mapdetail">
            {sortItemsArray.map((item, i) => {
                if (!this.keys[item.key]) return null;

                return (
                  <div key={i} className="row mapdetail_row">
                    <div className="col-lg-3 mapdetail_title">{(this.keys[item.key] && typeof this.keys[item.key].name === 'string') ? this.keys[item.key].name.toUpperCase() : ''}</div>
                    <div className="col-lg-9 mapdetail_desc">
                      {this.keys[item.key].name.toLowerCase() === 'prints' ?
                      Array.apply(null, {length: this.state.details[item.key]}).map((item, index) => {
                        const number = index+1;
                        const open = this.state.visiblePrint ? Number(this.state.visiblePrint-1) === index : undefined;
                        return (
                          <Button
                            key={index}
                            number={number}
                            activeNumber={this.state.activeNumber}
                            id={details.id}
                            open={open}
                            error={this.state.error}
                            onPressNumber={(id, number) => {
                              this.setState({ loading: true, visiblePrint: null }, () => {
                                this.props.onPressNumber(id, number);
                              });
                            }}
                            filterDetails={filterDetails}
                            message={this.state.message}
                            loading={this.state.loading}
                            data={this.state.response.data}
                            loadedSale={this.state.loadedSale}
                           />
                        )
                      }) : 
                      this.state.details[item.key]
                    }
                    </div>
                </div>  
              )
            })}

            {this.state.loadSale && <p>Loading sale details...</p>}
            {this.state.errorSale && <p>{this.state.errorSale || ''}</p>}
          </div>
        </div>
      </Rodal>
    )
  }
}
MapDetail.defaultProps = {}
MapDetail.propTypes = {}


// WEBPACK FOOTER //
// ./src/components/MapDetail.js